<template>
    <div>
        <bar-chart :xdata='xdata' :series='series' :rotate='45' :unit="'￥'" :type="'spend'"/>
    </div>
</template>
<script>
// 柱状图
import BarChart from '@/components/layouts/BarChart'
export default {
    computed:{
        xdata(){
            let arr=[]
            this.spendArr.map(item=>{
                arr.push(item.sicknessName)
            })
            return arr
        },
        series(){
            let data=[]
                    //   {
        //   name: 'pageA',
        //   type: 'bar',
        //   stack: 'vistors',
        //   barWidth: '60%',
        //   data: [79, 52, 200, 334, 390, 330, 220],
        //   animationDuration
        // },
             this.spendArr.map(item=>{
                //  data.push(item.totalAmount)
                 data.push({
                        name:item.sicknessName,
                     value:item.totalAmount,
                     datas:[item.caseNum,item.insuredNum]
                 })
             })
             return [{
                type: 'bar',
                stack: 'vistors',
                barWidth: '60%',
                data: data,
                 barMaxWidth:30,
                animationDuration:2000
             }]
        }
    },
    props:{
        spendArr:{
            type:Array,
            default:()=>[]
        }
    },
    components:{
        BarChart
    }
}
</script>